import React, { CSSProperties } from "react";
import * as styles from "./sidebar-user-menu-button.module.scss";
import { StyleableIcon } from "../../helper/icon-helper";
import { classArr } from "../../helper/style-helper";

export interface SidebarUserMenuButtonProps {
	style?: CSSProperties;
	className?: string;
	icon: StyleableIcon;
	label: string;
	onClick?: VoidFunction;
}

export default function SidebarUserMenuButton(
	props: SidebarUserMenuButtonProps,
) {
	return (
		<button
			style={props.style}
			className={classArr(props.className, styles.button)}
			onClick={props.onClick}
		>
			{props.icon(24, "currentColor")}
			{props.label}
		</button>
	);
}
